import React, { useMemo } from 'react';
import {
  RightContainer,
  WebGameColumn,
  WebGameColumnInner,
  WebGameMainCont,
  gameConfigStore,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { GameMain } from '../main';
import LeftColumn from '../../containers/common/leftColumn';
import { globalTranslationKeys } from '../../enums';
import {
  BetHistoryWrapper,
  LiveBetsWrapper,
  PopupsWrapper,
  TopAndCurrentWinnersWrapper,
} from '../../containers/common';
import { brandedGameIds } from '../../enums/brandedPartners';

import playForRealPopupImg from '../../assets/images/core/play-for-real-popup.png';
import defaultLogo from '../../assets/images/crash-game-type-logo.png';
import ecuabetCrashGameType from '../../assets/images/crash-game-type-logo-ecuabet.png';
import padisahCrashGameType from '../../assets/images/crash-game-type-logo-padisah.png';
import betofficeCrashGameType from '../../assets/images/crash-game-type-logo-betoffice.png';
import galabetCrashGameType from '../../assets/images/crash-game-type-logo-galabet.png';

export const WebMainWrapper = observer(() => {
  const { gameId, partnerId } = gameConfigStore;

  const rightContainerTabs = useMemo(
    () => [
      { name: globalTranslationKeys.LiveBets },
      { name: globalTranslationKeys.History, isBetHistory: true },
      { name: globalTranslationKeys.TopWinners },
    ],
    []
  );

  const brandedGameTypeLogos = useMemo(
    () => ({
      [brandedGameIds.padisah]: padisahCrashGameType,
      [brandedGameIds.ecuabet]: ecuabetCrashGameType,
      [brandedGameIds.betoffice]: betofficeCrashGameType,
      [brandedGameIds.betofficeByPartnerId]: betofficeCrashGameType,
      [brandedGameIds.galaBetByPartnerId]: galabetCrashGameType,
    }),
    []
  );

  const rightContainerTabsContainers = useMemo(
    () => [
      <LiveBetsWrapper />,
      <BetHistoryWrapper />,
      <TopAndCurrentWinnersWrapper isTopWinners />,
    ],
    []
  );

  return (
    <WebGameMainCont
      playForRealPopupImgSrc={playForRealPopupImg}
      lobbyLogoImageSrc={
        brandedGameTypeLogos[gameId] || brandedGameTypeLogos[partnerId] || defaultLogo
      }
      isShowBogLineLobby
      isShowIconTag
    >
      <LeftColumn />
      <WebGameColumn position='center'>
        <WebGameColumnInner position='center'>
          <GameMain />
        </WebGameColumnInner>
        <PopupsWrapper />
      </WebGameColumn>
      <RightContainer
        tabs={rightContainerTabs}
        tabContainers={rightContainerTabsContainers}
        hasHalfCashOut
        hasFreeBets
        hasAvatarsBlock
        hasChat
      />
    </WebGameMainCont>
  );
});
